export { RichText } from "./RichText";
export type { RichTextProps } from "./RichText";
